export class Parser {
    constructor(_shipBuild) {
        this._shipBuild = _shipBuild;
    }
}
